import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const SearchClearIcon = React.memo(({ className }: Props) => {
  return (
    <svg
      data-testid="search-clear-icon-svg"
      width="16"
      height="16"
      className={className}
      viewBox="0 0 16 16"
    >
      <path d="m8 0c4.4184 0 8 3.5816 8 8s-3.5816 8-8 8-8-3.5816-8-8 3.5816-8 8-8zm-2.892 4.4984c-.3368 0-.6096.2728-.6096.6096 0 .1688.0688.3224.18.4328l2.4592 2.4592-2.4592 2.4592c-.1112.1104-.18.2632-.18.4328 0 .3368.2728.6096.6096.6096.1688 0 .3224-.0688.4328-.18l2.4592-2.4592 2.4592 2.4592c.1104.1096.2624.1768.4296.1768.3368 0 .6096-.2728.6096-.6096 0-.168-.068-.3192-.1768-.4296l-2.4592-2.4592 2.4592-2.4592c.1096-.1104.1768-.2624.1768-.4296 0-.3368-.2728-.6096-.6096-.6096-.168 0-.3192.068-.4296.1768l-2.4592 2.4592-2.4592-2.4592c-.1104-.1112-.2632-.18-.4328-.18z" />
    </svg>
  );
}, arePropsEqual);

export default SearchClearIcon;
